import { render, staticRenderFns } from "./LongLivedApiKeys.vue?vue&type=template&id=1ef6d908&scoped=true&"
import script from "./LongLivedApiKeys.vue?vue&type=script&lang=js&"
export * from "./LongLivedApiKeys.vue?vue&type=script&lang=js&"
import style0 from "./LongLivedApiKeys.vue?vue&type=style&index=0&id=1ef6d908&scoped=true&lang=scss&"
import style1 from "./LongLivedApiKeys.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef6d908",
  null
  
)

export default component.exports